export default "__VITE_ASSET__B0qr8RNF__"